export default {
    consent_page_title: "Kevi | Autorizar agente de soporte",
    consent_title: "Autorizar agente de soporte",
    consent_logged_in_as: "Conectado como <strong>{0}</strong>.",
    consent_question: "¿Autorizar el WhatsApp <strong>{0}</strong> a consultar datos de la cuenta <strong>{1}</strong>?",
    consent_confirm: "Autorizar",
    consent_success_title: "Autorización completada",
    consent_success_subtitle: "El agente de soporte ya puede consultar los datos de esta cuenta para este WhatsApp.",
    consent_invalid_title: "Enlace inválido o expirado",
    consent_invalid_subtitle: "Solicite un nuevo enlace de autorización en el soporte.",
    consent_missing_request: "Enlace de autorización incompleto.",
    consent_confirm_error: "No se pudo completar la autorización. Inténtelo de nuevo.",
    manage_page_title: "Kevi | Autorizaciones del agente",
    manage_title: "Autorizaciones del agente de soporte",
    manage_description: "WhatsApps autorizados a consultar datos de esta cuenta vía agente de soporte.",
    manage_empty_title: "Aún no hay autorizaciones",
    manage_empty: "Ninguna autorización activa para agentes de soporte.",
    manage_address: "Dirección",
    manage_authorizer: "Autorizado por",
    manage_last_used: "Último uso",
    manage_actions: "Acciones",
    manage_revoke: "Revocar",
    manage_revoke_confirm: "¿Revocar esta autorización? El agente dejará de consultar datos de esta cuenta para este WhatsApp.",
    manage_revoke_success: "Autorización revocada con éxito.",
    manage_revoke_error: "No se pudo revocar la autorización.",
};
